\<script>
    import AnimationsMixin from "../../../author/pagesbuilder/mixins/AnimationsMixin";
    import {mapActions, mapState} from "vuex";
    import RowsMixin from "../../../author/pagesbuilder/mixins/RowsMixin";

    export default {
        name: "BlogPostListComponent",
        data () {
            return {
                componentType: "blogPostList"
            }
        },
        mixins: [
            AnimationsMixin,
            RowsMixin
        ],
        computed: {
            ...mapState('blog', [
                'blogPostPaginated',
                'currentBlogPostsPage',
                'blogPostsPages',
                'totalBlogPostItems'
            ]),
            getDefaultDataStructure () {
                return {
                    componentType: this.componentType,
                    componentId: this.componentId,
                    styles: {},
                    template: 'basicComponentTemplate',
                    cardType: 'blogpostlistcard1',
                    limitAmountOfCards: false,
                    limitCardAmount: this.blogPosts && this.blogPosts.length ? this.blogPosts.length : 4,
                    showSlider: false,
                    showFilters: false,
                    rows : 1,
                    cardsPerRow: 2,
                    itemVisibilitySettings: null
                }
            },
            getLoadMoreComponentData () {
                return {
                    label : this.$t('blog.load_more'),
                    display: this.currentRenderData.data && (this.componentData.rows * this.componentData.cardsPerRow < this.currentRenderData.data.length),
                    template: "load-more-button"
                }
            },
        },
        methods: {
            ...mapActions('blog', [
                'getBlogPostPaginated'
            ]),
            editBlogPostsData (newData) {
                newData = newData.filter(blogPost => {
                    // Do not show private blog posts
                    if (blogPost.access == 'private') {
                        return false;
                    }

                    blogPost.date = LWTranslate.formatTimestampLocalized(blogPost.published, "MMMM D, YYYY");
                    if (blogPost.image) {
                        blogPost.fullImagePath =  this.serverImg + blogPost.image;
                    } else if (blogPost.seo.image) {
                        blogPost.fullImagePath =  this.serverImg + blogPost.seo.image;
                    } else {
                        blogPost.fullImagePath =  this.imagePath + "/images/default_blog-post_image.jpg";
                    }

                    return blogPost;
                });

                return newData;
            },
            renderComponent () {
                console.log()
                // this.prepareDataToRender().then( result => { this.renderBlogPosts()});
            },
            renderBlogPosts () {
                let dataCopy = this.editBlogPostsData(copyJson(this.blogPostPaginated));

                let renderData = {
                    data: dataCopy,
                    amountOfCards : dataCopy.length,
                    ...this.componentData
                };

                this.renderTemplate(renderData.template, renderData).then( output => {
                    this.componentNode.innerHTML = output;

                    if (this.moreBlogPostsToShow()) {
                        const wrapper = this.componentNode.querySelector('.js-render-wrapper');
                        const buttonElement = this.createLoadMoreButton();
                        if (wrapper) {
                            wrapper.appendChild(buttonElement);
                        } else {
                            this.componentNode.appendChild(buttonElement )
                        }
                    }
                    this.addListeners();

                    this.currentRenderData = renderData;
                    this.renderingCompleted(renderData);
                })
            },
            createLoadMoreButton() {
                const loadMoreButton = `<div class="row">
    <div class="learnworlds-button-wrapper learnworlds-element">
        <button class="learnworlds-button full-width learnworlds-button-small learnworlds-button-solid-accent1 learnworlds-element js-load-more-button">
            <span>Load More</span>
        </button>
    </div>
</div>`;
                // Doing this to create a proper DOM node
                var dummy = document.createElement('div');
                dummy.innerHTML = loadMoreButton.trim();

                return dummy.firstChild;
            },
            addListeners() {
                // To be overridden
            },
            prepareDataToRender(){
                return new Promise ( (resolve,reject) => {
                    if (this.needMoreData() && this.canGetMoreData()) {
                        this.getBlogPostPaginated();
                    }

                    return new Promise((resolve, reject) => {
                        resolve(this.blogPostPaginated);
                    })

                })

            },
            needMoreData() {
                return !this.blogPostPaginated.length || this.myData.rows*this.myData.cardsPerRow > this.blogPostPaginated.length;
            },
            moreBlogPostsToShow() {
                if (this.totalBlogPostItems==0) {
                    return true;
                }
                return this.myData.rows*this.myData.cardsPerRow < this.totalBlogPostItems;
            },

            canGetMoreData() {
                // Check if the first request send
                if (this.currentBlogPostsPage===0) {
                    return true;
                }

                return this.currentBlogPostsPage < this.blogPostsPages;
            }
        },
        watch : {
            "myData": {
                deep: true,
                handler (newVal, oldVal) {
                    if (newVal.componentId) {
                        this.debouncedRenderComponent();
                    }
                }
            }
        }
    }
</script>

